import usePatientStore from '@patientMenu/hooks/usePatientStore.ts';
import SearchPatientForm, { SearchFormValues } from '@patientMenu/form/SearchPatientForm.tsx';

export function SearchPatients() {
  const { setQuery } = usePatientStore();
  const onSubmit = (data: SearchFormValues) => {
    setQuery({ search: data.searchQuery });
  };

  return <SearchPatientForm onSubmit={onSubmit} placeholder={'Search patient...'} />;
}
